var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.route.note)?_c('span',{staticClass:"route-note"},[_c('note',{attrs:{"note":_vm.route.note}}),_vm._v(" "),_c('span',{staticClass:"text--disabled number-of-note",attrs:{"title":`${_vm.route.note_count} ${_vm.$t('components.note.votes')}`}},[_vm._v("\n    ("+_vm._s(_vm.route.note_count)+")\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }